import { connect } from 'react-redux';

import CallScreen, {
  CallScreenStateProps,
  CallScreenDispatchProps,
} from '../components/CallScreen';
import {
  attachPlugin,
  createSession,
  joinRoom,
  listRoomParticipants,
  showNotification,
  toggleScreenSharing,
} from '../actionCreators';
import { StoreState } from '../reducers';

const mapStateToProps = ({ auth, call }: StoreState): CallScreenStateProps => ({
  loggedIn: auth.loggedIn,
  participants: call.participants,
  screenshare: call.screenshare,
  user: auth.user,
});

const mapDispatchToProps: CallScreenDispatchProps = {
  attachPlugin,
  createSession,
  joinRoom,
  listRoomParticipants,
  showNotification,
  toggleScreenSharing,
};

export default connect(mapStateToProps, mapDispatchToProps)(CallScreen);
